import React from "react";
import { RouteObject } from "react-router-dom";
import HomePage from "@/core/Pages/HomePage";
import ProductsPage from "@/core/Pages/ProductsPage";
import AboutPage from "@/core/Pages/AboutPage";
import LocationsPage from "@/core/Pages/LocationsPage";
import ContactPage from "@/core/Pages/ContactPage";
import LoginPage from "@/core/Dashboard/Login/LoginPage";
import RegisterPage from "@/core/Pages/RegisterPage";
import RefundPolicy from "@/core/Legal/RefundPolicy";
import PrivacyPolicy from "@/core/Legal/PrivacyPolicy";
import TermsOfService from "@/core/Legal/TermsOfService";
import ProfileDashboard from "./core/Dashboard/Profile";
import ForgotPasswordPage from "@/core/Pages/ForgotPasswordPage";
import NotFoundPage from "@/core/Errors/NotFoundPage";
// Import the correct component
import AllBlogs from "@/core/Pages/BlogPage";
import BlogPageTemplate from "@/core/Blogs/template/BlogPageLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/locations",
    element: <LocationsPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/account",
    element: <ProfileDashboard />,
  },
  {
    path: "/signup",
    element: <RegisterPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/refund-policy",
    element: <RefundPolicy />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  // Blog routes
  {
    path: "/blog",
    element: <AllBlogs />,
  },
  {
    path: "/:sk/*",
    element: <BlogPageTemplate />,
  },

  // Catch-all 404 route
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
